import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import LoadSVG from "../SLD/LoadSVG";

const Load = ({index,configured}) =>{
 return (
    <svg className="pointer"> 
      <LoadSVG id ={`Load`} />
      <CircuitBreakerSVG
              id={"_Load"}
               x ={"600"}
              y ={"370"}
              index ={index}
               isLoad ={true}
               configured={configured}
               cbRequiredSelection = {false}
            />
    </svg>
 )
}
export default Load;